import { updateFormioSubmission } from "../shared/api/yenta-api";

import { LANDER_QUIZ_EXTRA_ENTRIES } from "./lander-quiz.constants";
import {
  LanderQuizQuestion,
  LanderQuizQuestionTypeEnum,
  YesNoAnswersTypeEnum,
} from "./lander-quiz.types";

export interface SmsData {
  smsAccepted: boolean;
  phoneNumber: string;
}

export const trackLanderQuizVariable = (
  question: LanderQuizQuestion,
  yesNoBranchAnswer?: boolean
): void => {
  const answerLowerCase = question.answer?.toLowerCase() ?? "";

  let variableValue: string | string[] | boolean;

  switch (question.type) {
    case LanderQuizQuestionTypeEnum.YesNoBranchQuestion:
      variableValue =
        yesNoBranchAnswer ?? question.answer === YesNoAnswersTypeEnum.YES;
      break;
    case LanderQuizQuestionTypeEnum.MultiOptionGrid:
      variableValue = answerLowerCase.split(",");
      break;
    case LanderQuizQuestionTypeEnum.MultiOptionList:
      variableValue = answerLowerCase
        .split(",")
        .map((item) => encodeURIComponent(item));
      break;
    default:
      variableValue = answerLowerCase;
  }

  window.theme.LyticsService.landerQuizVariablesTracker({
    variableKey: question.lyticsProfileVariable,
    variableValue,
  });
};

export const grantLanderQuizExtraEntries = async (
  smsData: SmsData,
  handleWidgetError: (error: unknown) => void
) => {
  const { smsAccepted, phoneNumber } = smsData;

  const submission = window.theme.Sweepstake.prototype.retrieveSubmission();
  if (!submission) {
    return;
  }
  const sweepFormUrl =
    document
      .querySelector("#FormSweepstake")
      ?.getAttribute("data-form-path-url") || "";

  const patchData = {
    ...submission.data,
    quizExtraEntries:
      (submission.data?.quizExtraEntries || 0) + LANDER_QUIZ_EXTRA_ENTRIES,
    ...(smsAccepted &&
      phoneNumber && {
        smsMobilePhone: phoneNumber,
        smsTermsAndConditions: true,
      }),
  };

  await updateFormioSubmission(
    sweepFormUrl,
    {
      ...submission,
      data: patchData,
      is_lander_quiz_update: true,
    },
    handleWidgetError
  ).then((submission) => {
    window.theme.Sweepstake.prototype.storeSubmission(submission);
    window.theme.Sweepstake.prototype.storeSubmissionHash(submission);
  });
};
